module.exports = __webpack_public_path__ + "img/wide.2b065981.jpg";